import { useEffect, useState } from 'react';
import { Modal, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { IListResponse } from '../../types/list';
import { useFetch } from '../useFetch';

export const useRusPostTypes = () => {
    const dataFetch = useFetch();
    const deleteFetch = useFetch();
    const [data, setData] = useState<IListResponse>();
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const page = searchParams.get('page');

    const getData = async () => {
        let url = '/ruspost/types';

        if (typeof page === 'string') {
            url += `?page=${page}`;
        }

        const result = await dataFetch.request<IListResponse>({
            url,
            method: 'post',
        });
        if (result.success && result.data) {
            setData(result.data);
        }
    };

    const deleteRow = (id: number) => {
        Modal.confirm({
            title: t('confirmAction'),
            content: t('deleteConfirmation'),
            onOk: () => deleteFetch.request({
                url: `/ruspost/types/${id}/delete`,
                method: 'get',
            }).then(() => getData()),
            okText: t('delete'),
        });
    };

    const showHide = async (id: number) => {
        const result = await dataFetch.request<IListResponse>({
            url: `/ruspost/types/${id}/show-hide`,
            method: 'get',
        });
        if (result.success) {
            notification.success({ message: result.message });
            getData();
        }
    };

    useEffect(() => {
        getData();
    }, [page]);

    return {
        deleteRow,
        showHide,
        list: {
            data,
            loading: dataFetch.loading,
        },
    };
};
